/**
 * Custom element that implements a countdown timer.
 * This timer displays the remaining time until a specified end date.
 * The timer updates every second and stops once the target date is reached.
 */
class CountDownTimer extends HTMLElement {
  /**
   * Constructor to initialize the countdown timer element.
   * Selects the required DOM elements and sets the end date.
   */
  constructor() {
    super();

    // Define the selectors for days, hours, minutes, and seconds elements in the DOM
    this.selectors = {
      days: '[counter-days] [counter-number]',
      hours: '[counter-hours] [counter-number]',
      min: '[counter-min] [counter-number]',
      sec: '[counter-sec] [counter-number]',
    }

    // Get the end date from the 'data-end' attribute and convert it to a timestamp
    this.endDate = new Date(this.querySelector('.cdt-grid').dataset.end).getTime();
      console.log(this.endDate);
      
    // Initialize the countdown timer
    this.init();
  }

  /**
   * Initializes the countdown timer by updating the timer once
   * and then setting an interval to update it every second.
   */
  init() {
    this.updateTimer(); // Update the timer immediately upon initialization
    // Set an interval to update the timer every 1000 milliseconds (1 second)
    this.interval = setInterval(() => this.updateTimer(), 1000);
  }

  /**
   * Updates the countdown timer.
   * It calculates the remaining time and updates the display accordingly.
   */
  updateTimer() {
    const now = new Date().getTime(); // Get the current time
    const distance = this.endDate - now; // Calculate the remaining time

    // If the target time has passed, stop the timer and reset the display
    if (distance < 0) {
      clearInterval(this.interval); // Stop the interval updates
      this.updateDisplay(0, 0, 0, 0); // Display 0 for days, hours, minutes, and seconds
      this.remove();
      return;
    }

    // Calculate days, hours, minutes, and seconds remaining
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Update the display with the calculated values
    this.updateDisplay(days, hours, minutes, seconds);
  }

  /**
   * Updates the display with the given time values.
   * 
   * @param {number} days - The number of remaining days.
   * @param {number} hours - The number of remaining hours.
   * @param {number} minutes - The number of remaining minutes.
   * @param {number} seconds - The number of remaining seconds.
   */
  updateDisplay(days, hours, minutes, seconds) {
    // Update the corresponding DOM elements with the new values
    const pad = (num) => (num < 10 ? `0${num}` : num);

    this.querySelector(this.selectors.days).textContent = pad(days);
    this.querySelector(this.selectors.hours).textContent = pad(hours);
    this.querySelector(this.selectors.min).textContent = pad(minutes);
    this.querySelector(this.selectors.sec).textContent = pad(seconds);
  }
}

// Define the custom element, associating it with the 'count-down-timer' tag
customElements.define('count-down-timer', CountDownTimer);


